import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { IssueStatusFilter } from "./schema";

export async function getReconciliationRuns(api: ApiClient, signal?: AbortSignal) {
  return (await api.get<Schemas["ReconciliationRunView"][]>("/api/v1/admin/operations/reconciliations", {
    signal,
    cache: "no-store",
  })).data;
}

export async function getReconciliationRun(api: ApiClient, runId: number, signal?: AbortSignal) {
  return (await api.get<Schemas["ReconciliationRunView"]>(`/api/v1/admin/operations/reconciliations/${runId}`, {
    signal,
    cache: "no-store",
  })).data;
}

export async function getReconciliationIssues(api: ApiClient, status: IssueStatusFilter, signal?: AbortSignal) {
  return (await api.get<Schemas["ReconciliationIssueView"][]>("/api/v1/admin/operations/reconciliation-issues", {
    query: { status: status || undefined },
    signal,
    cache: "no-store",
  })).data;
}

export async function getReconciliationRunIssues(
  api: ApiClient,
  runId: number,
  query: { readonly status: IssueStatusFilter; readonly page: number; readonly size: number },
  signal?: AbortSignal,
) {
  return (await api.get<Schemas["AdminPageReconciliationIssueView"]>(`/api/v1/admin/operations/reconciliations/${runId}/issues`, {
    query: { status: query.status || undefined, page: query.page, size: query.size },
    signal,
    cache: "no-store",
  })).data;
}

export async function getReconciliationIssue(api: ApiClient, issueId: number, signal?: AbortSignal) {
  return (await api.get<Schemas["ReconciliationIssueView"]>(`/api/v1/admin/operations/reconciliation-issues/${issueId}`, {
    signal,
    cache: "no-store",
  })).data;
}

export async function runReconciliation(api: ApiClient, body: Schemas["RunReconciliationRequest"], signal?: AbortSignal) {
  return (await api.post<Schemas["ReconciliationRunView"], Schemas["RunReconciliationRequest"]>("/api/v1/admin/operations/reconciliations", body, {
    signal,
    cache: "no-store",
  })).data;
}

export async function resolveReconciliationIssue(api: ApiClient, issueId: number, body: Schemas["ResolveReconciliationIssueRequest"], signal?: AbortSignal) {
  return (await api.post<Schemas["ReconciliationIssueView"], Schemas["ResolveReconciliationIssueRequest"]>(`/api/v1/admin/operations/reconciliation-issues/${issueId}/resolution`, body, {
    signal,
    cache: "no-store",
  })).data;
}
